import React from 'react';
import ArticleWrapper from '../../components/ArticleWrapper';

const Neo70 = () => (
  <ArticleWrapper articleId="neo70">
    <div className="min-h-screen bg-[#111112] flex flex-col w-full">
      <div className="prose prose-invert mx-auto p-6">
        <h1>Neo70</h1>
        <img src="/pictures/gallery/gallery14.JPG" alt="Neo70" className="rounded-lg mb-6" />
        {/* Add your Neo70 article content here */}
      </div>
    </div>
  </ArticleWrapper>
);

export default Neo70;
